






























import { Vue, Component, Prop } from 'vue-property-decorator';

import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';
import TouristCard from '~/components/cards/TouristCard.vue';
import GlobalSwiper from '~/components/partials/GlobalSwiper.vue';
import MapOutline from '~/components/icons/MapOutline.vue';

@Component({
  components: { ChevronRightSolid, TouristCard, MapOutline, GlobalSwiper },
})
export default class TouristFeed extends Vue {
  @Prop(Array) providers: Array<Types.Provider>;
  @Prop(String) customTitle: '';
  @Prop(String) linkToExplorer: '';

  /* Skeleton length of fake cards to display based on user's window device */
  get skeletonLength () {
    if (process.client) {
      if (window.innerWidth < 1024 && window.innerWidth >= 768) return 3;
      return window.innerWidth < 768 ? 1 : 4;
    }
    return 4;
  }
}
